import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function ParkingLotLightingIcon(props) {
	return (
		<IconBase type="parking-lot-lighting" {...props}>
			<path d="M11.5 3.00009C11.5 2.69582 11.7695 2.46209 12.0707 2.50512L18.0707 3.36226C18.317 3.39745 18.5 3.60841 18.5 3.85724V5.92359C18.5 6.19973 18.2761 6.42359 18 6.42359H12C11.7239 6.42359 11.5 6.19973 11.5 5.92359V5.42359H8.5C7.67157 5.42359 7 6.09516 7 6.92359V21.4236H5V6.92359C5 4.99059 6.567 3.42359 8.5 3.42359H11.5V3.00009Z" />
			<path d="M15.5 10.4236V8.42358H14.5V10.4236H15.5Z" />
			<path d="M12.9393 8.19136L11.5251 9.60557L10.818 8.89846L12.2322 7.48425L12.9393 8.19136Z" />
			<path d="M19.182 8.89846L17.7678 7.48425L17.0607 8.19136L18.4749 9.60557L19.182 8.89846Z" />
		</IconBase>
	);
}
ParkingLotLightingIcon.propTypes = iconPropTypes;
